import defaultReducer from "@redux/modules/default.reducer";
import { TApiAction } from "@redux/store.types";
import { DISCRIMINATORS } from "./wishlist.discriminators";
import { WishlistModel } from "./@types/wishlist.model";

const discriminatorReducer = (
    state: any,
    action: TApiAction,
    constants: any,
    options: any,
    initialState: any,
) => {
    const { type, payload, actionOptions = {} } = action;

    if (type === constants.RESET) {
        return { ...initialState };
    }

    if (type === constants.PENDING) {
        return {
            ...state,
            params: payload,
            error: null,
            data: options.clearOnFetch ? null : state.data,
        };
    }

    const skipSuccessData = actionOptions?.skipSuccessData
        ? actionOptions.skipSuccessData()
        : false;

    if (type === constants.SUCCESS) {
        if (actionOptions.discriminator === DISCRIMINATORS.LoadOne) {
            return {
                ...state,
                error: null,
                data: [
                    ...(state?.data || []).filter((wishlist: WishlistModel) => wishlist.id !== action.payload.id),
                    action.payload
                ],
            };
        }

        return {
            ...state,
            error: null,
            data: skipSuccessData ? state.data : payload,
        };
    }

    if (type === constants.FAILURE) {
        return {
            ...state,
            error: payload,
            data: options.clearOnError ? null : state.data,
        };
    }

    return state;
};

const WishlistReducer = (
    state: any,
    action: TApiAction,
    constants: any,
    options: any,
    initialState: any,
) => {
    return discriminatorReducer(state, action, constants, options, initialState);
};

export default WishlistReducer;
